export class CalculationOverridesInput {
    additionalThickness: string;
    boltHoleDiameter: string;
    distanceToNearestObstruction: string;
    gasketCompThickness: string;
    jointThickness: string;
    kFactor: number;
    m: string;
    maximumGasketStress: string;
    minimumGasketStress: string;
    minimumBoltDiameter: string;
    operatingPressure: string;
    operatingTemperature: string;
    pAdditional?: number;
    pipeSchedule: string;
    pipeSize: string;
    recommendedGasketStress: string;
    standard: string;
    testPressure: string;
    y: string;
}
